import { render, staticRenderFns } from "./realEstateNuki.vue?vue&type=template&id=08a536bd&"
import script from "./realEstateNuki.vue?vue&type=script&lang=js&"
export * from "./realEstateNuki.vue?vue&type=script&lang=js&"
import style0 from "./realEstateNuki.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports